module.exports = "  <p class=\"side-nav-text\">\n    In case, If you want to hire me!\n    It's worth a shot\n  </p>\n\n<mat-accordion class=\"example-headers-align\">\n  <!--do not change the type string-->\n  <app-resume-item [step]=\"'step === 0'\" [type]=\"'experience'\"></app-resume-item>\n  <app-resume-item [step]=\"'step === 1'\" [type]=\"'education'\"></app-resume-item>\n</mat-accordion>\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/resume/resume.component.html
// module id = ../../../../../src/app/displayer/resume/resume.component.html
// module chunks = main